import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
  TripNavigationData,
  TripQueryParams,
} from '../components/trip-navigation/interfaces/trip-navigation.interfaces';

@Injectable({
  providedIn: 'root',
})
export class TripNavigationService {
  private readonly basePath: string[] = ['monitor', 'principal-screen'];

  private readonly dialog = inject(MatDialog);

  constructor(private router: Router) {}

  navigateToTrip(
    trip: TripNavigationData,
    additionalParams: TripQueryParams = {},
    openInNewTab: boolean = true,
  ): void {
    const queryParams: TripQueryParams = {
      // The monitor screen matches trips by their NUMERIC id, not the Mongo _id.
      tripId: trip.id != null ? String(trip.id) : undefined,
      ...additionalParams,
    };

    const urlTree = this.router.createUrlTree(this.basePath, { queryParams });

    if (openInNewTab) {
      const url = window.location.origin + this.router.serializeUrl(urlTree);
      window.open(url, '_blank');
    } else {
      // Same-tab navigation replaces the current page, so close any open dialog
      // (e.g. the document detail modal) that would otherwise float on top.
      this.dialog.closeAll();
      this.router.navigateByUrl(urlTree);
    }
  }

  createTripUrl(trip: TripNavigationData, queryParams: TripQueryParams = {}): string {
    const params = {
      // The monitor screen matches trips by their NUMERIC id, not the Mongo _id.
      tripId: trip.id != null ? String(trip.id) : undefined,
      ...queryParams,
    };
    const urlTree = this.router.createUrlTree(this.basePath, { queryParams: params });
    return window.location.origin + this.router.serializeUrl(urlTree);
  }

  isTripNavigable(trip: TripNavigationData): boolean {
    if (!trip) return false;
    return !!trip._id || !!trip.id;
  }

  getNavigationDescription(): string {
    return 'Ver en Monitor de Rutas';
  }
}
